import React, { useEffect, useState } from 'react'
import styles from './index.module.css'
import { UserResponse } from '../../models'
import CorporateFareIcon from '@mui/icons-material/CorporateFare';
import GroupIcon from '@mui/icons-material/Group';
import DescriptionIcon from '@mui/icons-material/Description';
import { Menu } from '@mui/icons-material';
import LogoutIcon from '@mui/icons-material/Logout';
import { useLocation, useNavigate } from 'react-router-dom';

export default function Header() {
    const navigate = useNavigate()
    const location = useLocation()
    const [userData, setUserData] = useState<UserResponse>()
    const [mobileMenu, setMobileMenu] = useState<boolean>(false)
    const [profileMenu, setProfileMenu] = useState<boolean>(false)


    const handleLogout = () => {
        localStorage.removeItem('token')
        navigate('/login')
    }

    const handleGetUserData = async () => {
        const savedUserData = localStorage.getItem('userData')
        if (!savedUserData) {
            return
        }

        const data = JSON.parse(savedUserData)
        setUserData(data)
    }

    const getMenuItemClass = (path?: string) => {
        if (path && location.pathname === path) {
            return `${styles.menuItem} ${styles.activeMenuItem}`
        }

        return styles.menuItem
    }

    useEffect(() => {
        handleGetUserData()
    },[])

  return (
    <div className={styles.background}>
        <img className={styles.logo} src='/assets/images/novolar_logo.png' alt='Novolar' onClick={() => navigate('/imoveis')}/>
        <div className={mobileMenu? styles.mobileMenu : styles.navigation}>
            <div className={getMenuItemClass('/imoveis')} onClick={() => navigate('/imoveis')}>
                <CorporateFareIcon /> 
                <p>Imóveis</p>
            </div>
            {(userData?.account_type === 'admin' || userData?.account_type === 'IMOBILIARIA') && <>
                <div className={getMenuItemClass('/usuarios')} onClick={() => navigate('/usuarios')}>
                    <GroupIcon /> 
                    <p>Usuários</p>
                </div>
                <div className={getMenuItemClass('/logs')} onClick={() => navigate('/logs')}>
                    <DescriptionIcon /> 
                    <p>Logs</p>
                </div>
            </>}
        </div>
        <div className={styles.profileTrigger} onClick={() => setProfileMenu(!profileMenu)}>
            <p>{`Bem-vindo, ${userData?.first_name ?? ''}`}</p>
            <img className={styles.userPicture} src={userData?.photo ?? '/assets/images/user.png'} alt='User profile' />
        </div>
        <div className={styles.mobileMenuIcon}>
            <Menu onClick={() => setMobileMenu(!mobileMenu)}/>
        </div>
        {profileMenu &&
            <div className={styles.profileMenu}>
                <div className={styles.menuItem} onClick={handleLogout}>
                    <LogoutIcon /> 
                    <p>Sair</p>
                </div>
            </div>
        }
    </div>
  )
}
